import axios from 'axios';

/**
 * Performs a health check on the API endpoint
 * @param {number} timeout - Timeout in milliseconds (default: 5000)
 * @returns {Promise<boolean>} - Returns true if health check passes (status 200), false otherwise
 */
export const checkApiHealth = async (timeout = 5000) => {
  const healthCheckUrl = process.env.REACT_APP_HEALTH_CHECK_URL;

  if (!healthCheckUrl) {
    console.warn('REACT_APP_HEALTH_CHECK_URL is not defined');
    return false;
  }

  try {
    const response = await axios.get(healthCheckUrl, {
      timeout,
      validateStatus: (status) => status === 200,
    });

    return response.status === 200;
  } catch (error) {
    // Network errors, timeouts, or non-200 status codes
    return false;
  }
};

